/* RIFT // VOLT — motion: reveals, hero field, scroll effects, cursor, bike filter */
(() => {
  const d = document, root = d.documentElement;
  const RM = matchMedia('(prefers-reduced-motion: reduce)').matches;
  const FINE = matchMedia('(pointer: fine)').matches;
  const INTRO = root.classList.contains('rx-intro');
  const $ = (s, c = d) => c.querySelector(s);
  const $$ = (s, c = d) => [...c.querySelectorAll(s)];
  const clamp = (v, a, b) => Math.min(b, Math.max(a, v));
  const lerp = (a, b, t) => a + (b - a) * t;
  const esc = (s) => String(s == null ? '' : s).replace(/[&<>"']/g, (c) => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]));

  /* ---------- split text ---------- */
  function split(el) {
    if (el.dataset.splitDone) return;
    el.dataset.splitDone = '1';
    el.setAttribute('aria-label', el.textContent.replace(/\s+/g, ' ').trim());
    let i = 0;
    const walk = (node) => {
      [...node.childNodes].forEach((n) => {
        if (n.nodeType === 3) {
          const frag = d.createDocumentFragment();
          n.textContent.split(/(\s+)/).forEach((w) => {
            if (!w) return;
            if (/^\s+$/.test(w)) { frag.append(' '); return; }
            const word = d.createElement('span');
            word.className = 'rx-w';
            word.setAttribute('aria-hidden', 'true');
            [...w].forEach((ch) => {
              const c = d.createElement('span');
              c.className = 'rx-c';
              c.textContent = ch;
              c.style.setProperty('--i', i++);
              word.append(c);
            });
            frag.append(word);
          });
          n.replaceWith(frag);
        } else if (n.nodeType === 1) walk(n);
      });
    };
    walk(el);
  }

  /* ---------- reveal ---------- */
  const io = new IntersectionObserver((entries) => {
    entries.forEach((e) => {
      if (e.isIntersecting) { e.target.classList.add('is-in'); io.unobserve(e.target); }
    });
  }, { rootMargin: '0px 0px -8% 0px', threshold: 0.1 });
  function initReveal(scope = d) {
    $$('[data-split]', scope).forEach(split);
    $$('[data-reveal],[data-split]', scope).forEach((el) => {
      if (el.closest('.rx-hero')) return;
      if (RM) el.classList.add('is-in'); else io.observe(el);
    });
  }

  /* ---------- hero ---------- */
  function initHero(hero) {
    $$('[data-split]', hero).forEach(split);
    const go = () => {
      hero.classList.add('is-live');
      $$('[data-split]', hero).forEach((el) => el.classList.add('is-in'));
    };
    setTimeout(go, INTRO && !RM ? 1050 : 60);

    const visual = $('.rx-hero__visual', hero);
    if (visual && FINE && !RM) {
      hero.addEventListener('pointermove', (e) => {
        const r = hero.getBoundingClientRect();
        const x = (e.clientX - r.left) / r.width - 0.5, y = (e.clientY - r.top) / r.height - 0.5;
        visual.style.setProperty('--px', (x * 26).toFixed(1) + 'px');
        visual.style.setProperty('--py', (y * 26).toFixed(1) + 'px');
      });
      hero.addEventListener('pointerleave', () => { visual.style.setProperty('--px', '0px'); visual.style.setProperty('--py', '0px'); });
    }
    const clock = $('[data-clock]', hero);
    if (clock) {
      const tick = () => { clock.textContent = new Date().toLocaleTimeString([], { hour: '2-digit', minute: '2-digit', second: '2-digit', hour12: false }); };
      tick(); setInterval(tick, 1000);
    }
    const cv = $('.rx-hero__canvas', hero);
    if (cv && !RM) heroField(cv, hero);
    const hv = $('[data-hero-video]', hero);
    if (hv) heroVideo(hv);
  }

  /* hero video frame: timecode, pause/sound controls, pause while off-screen */
  function heroVideo(box) {
    const v = $('video', box);
    if (!v) return;
    const time = $('[data-hero-time]', box), playBtn = $('[data-hero-play]', box), soundBtn = $('[data-hero-sound]', box);
    const fmt = (s) => { s = Math.floor(s || 0); return String(Math.floor(s / 60)).padStart(2, '0') + ':' + String(s % 60).padStart(2, '0'); };
    let userPaused = RM;
    v.muted = true;
    if (RM) { v.removeAttribute('autoplay'); v.pause(); }
    const sync = () => {
      if (playBtn) playBtn.textContent = v.paused ? 'Play' : 'Pause';
      if (soundBtn) { soundBtn.textContent = v.muted ? 'Sound on' : 'Mute'; soundBtn.setAttribute('aria-pressed', String(!v.muted)); }
    };
    v.addEventListener('timeupdate', () => { if (time) time.textContent = fmt(v.currentTime) + ' / ' + fmt(v.duration); });
    ['play', 'pause', 'volumechange'].forEach((ev) => v.addEventListener(ev, sync));
    if (playBtn) playBtn.addEventListener('click', () => { userPaused = !v.paused; if (userPaused) v.pause(); else v.play(); });
    if (soundBtn) soundBtn.addEventListener('click', () => { v.muted = !v.muted; if (!v.muted && v.paused) { userPaused = false; v.play(); } });
    new IntersectionObserver(([e]) => {
      if (e.isIntersecting) { if (!userPaused) v.play().catch(() => {}); } else v.pause();
    }, { threshold: 0.2 }).observe(box);
    sync();
  }

  /* electric flow-field: sparks stream out of the rift line */
  function heroField(cv, hero) {
    const ctx = cv.getContext('2d');
    let w = 0, h = 0, dpr = 1, running = false, t = 0, mx = -9999, my = -9999;
    const parts = [];
    const N = innerWidth < 700 ? 70 : 150;
    const tilt = Math.tan(14 * Math.PI / 180);
    const riftX = (y) => w * 0.62 + (y - h / 2) * -tilt;
    function size() {
      dpr = Math.min(devicePixelRatio || 1, 2);
      w = cv.clientWidth; h = cv.clientHeight;
      cv.width = w * dpr; cv.height = h * dpr;
      ctx.setTransform(dpr, 0, 0, dpr, 0, 0);
    }
    function spawn(p) {
      p.y = Math.random() * h;
      p.x = riftX(p.y) + (Math.random() - 0.5) * 6;
      p.dir = Math.random() < 0.5 ? -1 : 1;
      p.vx = p.dir * (0.4 + Math.random() * 1.6);
      p.vy = (Math.random() - 0.5) * 0.6;
      p.life = 0;
      p.max = 120 + Math.random() * 260;
      p.w = Math.random() * 1.4 + 0.4;
      p.c = Math.random() < 0.7 ? '255,255,255' : '150,150,158';
      return p;
    }
    function frame() {
      if (!running) return;
      t += 1;
      ctx.globalCompositeOperation = 'destination-out';
      ctx.fillStyle = 'rgba(0,0,0,0.09)';
      ctx.fillRect(0, 0, w, h);
      ctx.globalCompositeOperation = 'lighter';
      for (const p of parts) {
        const ox = p.x, oy = p.y;
        const n = Math.sin(p.y * 0.006 + t * 0.012) + Math.cos(p.x * 0.004 - t * 0.008);
        p.vy += n * 0.035;
        p.vx += p.dir * 0.012;
        const dx = p.x - mx, dy = p.y - my, dist = dx * dx + dy * dy;
        if (dist < 22000) { const f = (22000 - dist) / 22000; p.vx += (dx / 140) * f; p.vy += (dy / 140) * f; }
        p.vx *= 0.985; p.vy *= 0.94;
        p.x += p.vx; p.y += p.vy; p.life++;
        const a = Math.sin((p.life / p.max) * Math.PI) * 0.75;
        ctx.strokeStyle = `rgba(${p.c},${a.toFixed(3)})`;
        ctx.lineWidth = p.w;
        ctx.beginPath(); ctx.moveTo(ox, oy); ctx.lineTo(p.x, p.y); ctx.stroke();
        if (p.life > p.max || p.x < -20 || p.x > w + 20 || p.y < -20 || p.y > h + 20) spawn(p);
      }
      requestAnimationFrame(frame);
    }
    size();
    for (let i = 0; i < N; i++) { const p = spawn({}); p.life = Math.random() * p.max; parts.push(p); }
    addEventListener('resize', size);
    hero.addEventListener('pointermove', (e) => { const r = cv.getBoundingClientRect(); mx = e.clientX - r.left; my = e.clientY - r.top; });
    hero.addEventListener('pointerleave', () => { mx = my = -9999; });
    new IntersectionObserver(([e]) => {
      const on = e.isIntersecting && !d.hidden;
      if (on && !running) { running = true; requestAnimationFrame(frame); } else if (!on) running = false;
    }).observe(hero);
  }

  /* ---------- header + scroll loop ---------- */
  const header = $('[data-header]');
  const marquees = $$('.rx-marquee');
  const hscrolls = $$('.rx-hscroll');
  const statements = $$('[data-words]').map((el) => {
    const words = el.textContent.trim().split(/\s+/);
    el.setAttribute('aria-label', el.textContent.replace(/\*/g, '').trim());
    el.innerHTML = words.map((w) => {
      const volt = /\*/.test(w);
      return `<span class="w${volt ? ' is-volt' : ''}" aria-hidden="true">${esc(w.replace(/\*/g, ''))}</span>`;
    }).join(' ');
    return { el, words: $$('.w', el), lit: -1 };
  });
  let lastY = scrollY, skew = 0;
  function sizeHscroll() {
    hscrolls.forEach((sec) => {
      const track = $('.rx-hscroll__track', sec);
      if (innerWidth < 768 || RM) { sec.style.height = ''; sec._max = 0; return; }
      const max = Math.max(0, track.scrollWidth - innerWidth + 48);
      sec._max = max;
      sec.style.height = (max + innerHeight) + 'px';
    });
  }
  /* scale one-line display text (footer wordmark) to exactly fill its box */
  function fitText() {
    $$('[data-fit-text]').forEach((el) => {
      el.style.fontSize = '';
      const fs = parseFloat(getComputedStyle(el).fontSize);
      if (el.scrollWidth) el.style.fontSize = Math.min(260, fs * (el.clientWidth / el.scrollWidth) * 0.99).toFixed(1) + 'px';
    });
  }
  function loop() {
    const y = scrollY, vy = y - lastY;
    if (header) {
      header.classList.toggle('is-scrolled', y > 24);
      if (!root.classList.contains('rx-lock')) header.classList.toggle('is-hidden', vy > 0 && y > 320);
    }
    if (!RM) {
      skew = lerp(skew, clamp(vy * 0.12, -5, 5), 0.12);
      if (Math.abs(skew) < 0.01) skew = 0;
      marquees.forEach((m) => m.style.setProperty('--skew', skew.toFixed(3)));
    }
    hscrolls.forEach((sec) => {
      if (!sec._max) return;
      const r = sec.getBoundingClientRect();
      const p = clamp(-r.top / (r.height - innerHeight), 0, 1);
      $('.rx-hscroll__track', sec).style.transform = `translate3d(${(-p * sec._max).toFixed(1)}px,0,0)`;
      sec.style.setProperty('--p', p.toFixed(4));
    });
    statements.forEach((s) => {
      const r = s.el.getBoundingClientRect();
      if (r.bottom < -200 || r.top > innerHeight + 200) return;
      const p = RM ? 1 : clamp((innerHeight * 0.82 - r.top) / (r.height + innerHeight * 0.3), 0, 1);
      const n = Math.round(p * s.words.length);
      if (n !== s.lit) { s.lit = n; s.words.forEach((w, i) => w.classList.toggle('is-lit', i < n)); }
    });
    lastY = y;
    requestAnimationFrame(loop);
  }

  /* ---------- magnetic + tilt + cursor ---------- */
  function initPointerFx() {
    if (!FINE || RM) return;
    $$('[data-magnetic]').forEach((el) => {
      el.addEventListener('pointermove', (e) => {
        const r = el.getBoundingClientRect();
        el.style.transform = `translate(${((e.clientX - r.left - r.width / 2) * 0.22).toFixed(1)}px,${((e.clientY - r.top - r.height / 2) * 0.3).toFixed(1)}px)`;
      });
      el.addEventListener('pointerleave', () => { el.style.transform = ''; });
    });

    let tiltCard = null;
    d.addEventListener('pointermove', (e) => {
      const card = e.target.closest && e.target.closest('.rx-card');
      if (tiltCard && tiltCard !== card) { tiltCard.classList.remove('is-tilting'); tiltCard.style.removeProperty('--rx'); tiltCard.style.removeProperty('--ry'); }
      tiltCard = card;
      if (!card) return;
      const r = card.getBoundingClientRect();
      const x = (e.clientX - r.left) / r.width, y = (e.clientY - r.top) / r.height;
      card.classList.add('is-tilting');
      card.style.setProperty('--ry', ((x - 0.5) * 9).toFixed(2) + 'deg');
      card.style.setProperty('--rx', ((0.5 - y) * 9).toFixed(2) + 'deg');
      card.style.setProperty('--gx', (x * 100).toFixed(1) + '%');
      card.style.setProperty('--gy', (y * 100).toFixed(1) + '%');
    }, { passive: true });

    const cur = d.createElement('div');
    cur.className = 'rx-cursor is-gone';
    cur.setAttribute('aria-hidden', 'true');
    cur.innerHTML = '<div class="rx-cursor__ring"><span>View</span></div><div class="rx-cursor__dot"></div>';
    d.body.append(cur);
    root.classList.add('rx-has-cursor');
    const ring = $('.rx-cursor__ring', cur), dot = $('.rx-cursor__dot', cur);
    let x = -100, y = -100, rx = -100, ry = -100;
    addEventListener('pointermove', (e) => {
      if (e.pointerType !== 'mouse') return;
      x = e.clientX; y = e.clientY;
      dot.style.transform = `translate3d(${x}px,${y}px,0)`;
      cur.classList.remove('is-gone');
    }, { passive: true });
    d.addEventListener('pointerleave', () => cur.classList.add('is-gone'));
    d.addEventListener('pointerover', (e) => {
      const t = e.target;
      const view = t.closest && t.closest('.rx-card__link,.rx-card__media,[data-cursor="view"]');
      cur.classList.toggle('is-view', !!view);
      cur.classList.toggle('is-hover', !view && !!(t.closest && t.closest('a,button,label,select,summary,[data-cursor]')));
    });
    (function follow() {
      rx = lerp(rx, x, 0.2); ry = lerp(ry, y, 0.2);
      ring.style.transform = `translate3d(${rx.toFixed(1)}px,${ry.toFixed(1)}px,0)`;
      requestAnimationFrame(follow);
    })();
  }

  /* ---------- garage (fitment filter) ---------- */
  $$('[data-garage]').forEach((sec) => {
    const btns = $$('[data-fit]', sec), cards = $$('.rx-card', sec), empty = $('.rx-garage__empty', sec), count = $('[data-fit-count]', sec);
    btns.forEach((b) => b.addEventListener('click', () => {
      const tag = (b.dataset.fit || '').toLowerCase();
      btns.forEach((x) => { const on = x === b; x.classList.toggle('is-active', on); x.setAttribute('aria-pressed', on); });
      let shown = 0;
      cards.forEach((c) => {
        const tags = (c.dataset.tags || '').toLowerCase().split('|');
        const ok = !tag || tags.includes(tag);
        c.classList.toggle('is-hidden', !ok);
        c.classList.remove('is-pop');
        if (ok) { c.style.setProperty('--stagger', (shown * 45) + 'ms'); void c.offsetWidth; if (!RM) c.classList.add('is-pop'); shown++; }
      });
      if (empty) empty.hidden = shown > 0;
      if (count) count.textContent = String(shown).padStart(2, '0');
    }));
  });

  /* ---------- boot ---------- */
  initReveal();
  const hero = $('.rx-hero');
  if (hero) initHero(hero);
  initPointerFx();
  sizeHscroll();
  fitText();
  if (d.fonts && d.fonts.ready) d.fonts.ready.then(() => { fitText(); sizeHscroll(); });
  let rt = 0;
  addEventListener('resize', () => { clearTimeout(rt); rt = setTimeout(() => { sizeHscroll(); fitText(); }, 120); });
  addEventListener('load', () => { sizeHscroll(); fitText(); });
  requestAnimationFrame(loop);
  d.addEventListener('shopify:section:load', (e) => {
    initReveal(e.target);
    $$('[data-reveal],[data-split]', e.target).forEach((el) => el.classList.add('is-in'));
    const h = $('.rx-hero', e.target);
    if (h) initHero(h);
  });
})();